import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from 'vue';
import { WhatsappCodeService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { useUiStore } from '@/stores';
import { NumberModel, WhatsappCodeServiceGetNumbersParams } from '@/types';
import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';
import WhatsappCodeNumberListItem from './components/WhatsappCodeNumberListItem.vue';

const perPage = 10;

export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsappCodeListPage',
  setup(__props, { expose: __expose }) {
  __expose();

const numbers = ref<NumberModel[]>([]);
const count = ref(0);
const currentPage = ref(1);
const search = ref('');

const uiStore = useUiStore();
const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const getParams = (): WhatsappCodeServiceGetNumbersParams => ({
    page: currentPage.value,
    per_page: perPage,
    search: search.value || undefined,
});

const fetchNumbers = async () => {
    setLoading(true);
    try {
        const { data, headers } = await WhatsappCodeService.getNumbers({
            params: getParams(),
        });
        numbers.value = data;
        count.value = parseInt(headers['x-pagination-count']) || data.length;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

watch([currentPage], () => {
    fetchNumbers();
});

watch([search], () => {
    if (currentPage.value === 1) fetchNumbers();
    else currentPage.value = 1;
});

onMounted(() => {
    fetchNumbers();
});

const __returned__ = { numbers, count, perPage, currentPage, search, uiStore, setLoading, getParams, fetchNumbers, SVGWhatsApp, WhatsappCodeNumberListItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})